export default __webpack_public_path__ + "static/media/landingpage-empty-state.9c435030.svg";